const dev = {
  appointment_api_url: `https://node-doctor.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  symptoms_api_url: `https://strauss-symptoms.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  examination_api_url: `https://strauss-examination.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  diagnosis_api_url: `https://strauss-diagnosis.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  advice_api_url: `https://strauss-advice.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  investigation_api_url: `https://strauss-investigation.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  medication_api_url: `https://strauss-medicine.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  vitals_api_url: `https://strauss-vital.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  casemanager_api_url: `https://strauss-casemanager.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  printsettings_api_url: `https://strauss-printsettings.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  medicalhistory_api_url: `https://strauss-medicalhistory.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  videolibrary_api_url: `https://strauss-videolibrary.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  sso_to_pm_url: `https://pms-upgrade.azurewebsites.net/api/get_doctor_sso_token.php`,
  sso_to_pm_admin_url: `https://pms-upgrade.azurewebsites.net/api/get_doctor_admin_sso_token.php`,
  sso_to_pm_username: `PM_40d30f01184aedc47`,
  sso_to_pm_password: `487154d8-b9ad-4314-a0e3-a72d5se84x14`,
  doctor_website_url: `https://pms-upgrade.azurewebsites.net/doctor_website/`,
  vaccination_api_url: `https://pm-vaccination-uat.mytatva.in/`,
  GROWTHBOOK_CLIENTKEY: "sdk-8jXEPwxajRuwkiyD",
  growth_chart_api_url: `https://pm-uat-growth-chart.tatvacare.in`,
  firebaseApiKey: "AIzaSyAfD-YLOjDLbhC7hwyiumSkNxP2lul_Kc0",
  firebaseAuthDomain: "diginext-28149.firebaseapp.com",
  firebaseDatabaseURL: "https://tc-care-default-rtdb.firebaseio.com",
  firebaseProjectId: "diginext-28149",
  firebaseStorageBucket: "diginext-28149.appspot.com",
  firebaseMessagingSenderId: "482265957598",
  firebaseAppId: "1:482265957598:web:5ecc05efdbed5c63f42e4f",
  tatvaRedirect: "https://diginextdoctor72093uat.azureedge.net/#/content?auto",
  gynec_api_url:
    "https://pm-medicalhistory-uat.tatvacare.in/api/v1/gynec-history",
  obstetric_api_url:
    "https://pm-medicalhistory-uat.tatvacare.in/api/v1/obstetric-history",
  zydus_api_url: `https://pm-ingest-webhook-uat.tatvacare.in`,
  zydus_business_id: "754811713438773",
  zydus_proxy_url: "https://pm-ict-proxy-uat.tatvacare.in",
  rx_digitization: "https://pm-rxdigitization-uat.tatvacare.in",
  visit_api_url: "https://pm-visit-integration-uat.tatvacare.in",
  user_management_api_url: "https://user-management77913uat.azurewebsites.net",
  razorpay_integration_url: "https://pm-razorpay-uat-integration.tatvacare.in",
  api_secret_key: "194627f7-u6hu-4378-q0e2-a34t5lt77f31",
  api_key: "TC_12o89l11327dfrt55",
  lab_params_api_url: "https://pm-patient-docs-uat.tatvacare.in",
  opd_encryption_url:
    "https://api-uat.mytatva.in/api/v8/helper/encrypt_visit_data",
  opd_visit_url: "https://visit-enrolment-tatva.getvisitapp.net",
  upload_doc_api_url: "https://pm-patient-docs-uat.tatvacare.in",
  central_auth_api_url: "https://pm-central-auth-uat.tatvacare.in",
  pedia_logout_url: "https://doctor-uat.tatvacare.in/#logout_user=1",
  bulk_messages: "https://pm-communication-uat.tatvacare.in",
  searchengine_url: "https://pm-searchengine-uat.tatvacare.in",
  razorPay_key: "rzp_test_PoLtBba5t8qJIm",
  tatvaAi_api_url: "https://pm-doctor-tatva-uat.tatvacare.in",
  tatvaAi_url: "https://tatva-ai-uat.tatvacare.in",
  tatvaAi_logout_url:"https://tatva-ai-uat.tatvacare.in/logout",
  lite_api_key: "68ceb696-0b60-47e8-9deb-b0e359d93d2f",
  lite_secret_key: "4b301416-946d-4b22-a083-69111ce79245",
  gen_rx_api_url: "https://pm-rxdigitization-qa.tatvacare.in",
  tatvaPedia_api_url: "https://diginext-authserver-uat.tatvacare.in",
  tatvaPedia_domain_url: "https://diginextdoctor72093uat.azureedge.net",
};

const qa_tp = {
  appointment_api_url: `https://pm-master-webservice-qa.tatvacare.in/`,
  symptoms_api_url: `https://pm-symptoms-qa.tatvacare.in`,
  examination_api_url: `https://pm-examination-qa.tatvacare.in`,
  diagnosis_api_url: `https://pm-diagnosis-qa.tatvacare.in`,
  advice_api_url: `https://pm-advice-qa.tatvacare.in`,
  investigation_api_url: `https://pm-investigation-qa.tatvacare.in`,
  medication_api_url: `https://pm-medicine-qa.tatvacare.in/`,
  vitals_api_url: `https://pm-vital-qa.tatvacare.in`,
  casemanager_api_url: `https://pm-casemanager-qa.tatvacare.in`,
  printsettings_api_url: `https://pm-printsetting-qa.tatvacare.in`,
  medicalhistory_api_url: `https://pm-medicalhistory-qa.tatvacare.in`,
  videolibrary_api_url: `https://pm-videolibrary-qa.tatvacare.in`,
  sso_to_pm_url: `https://pm-uat-dhspl-2.tatvacare.in/api/get_doctor_sso_token.php`,
  sso_to_pm_admin_url: `https://pm-uat-dhspl-2.tatvacare.in/api/get_doctor_admin_sso_token.php`,
  sso_to_pm_username: `PM_40d30f01184aedc47`,
  sso_to_pm_password: `487154d8-b9ad-4314-a0e3-a72d5se84x14`,
  doctor_website_url: `https://pm-doctor-portal-qa.tatvacare.in/doctor_website/`,
  vaccination_api_url: `https://pm-vaccination-qa.tatvacare.in/`,
  GROWTHBOOK_CLIENTKEY: "sdk-8jXEPwxajRuwkiyD",
  growth_chart_api_url: `https://pm-growth-chart-qa.tatvacare.in`,
  firebaseApiKey: "AIzaSyAfD-YLOjDLbhC7hwyiumSkNxP2lul_Kc0",
  firebaseAuthDomain: "diginext-28149.firebaseapp.com",
  firebaseDatabaseURL: "https://tc-care-default-rtdb.firebaseio.com",
  firebaseProjectId: "diginext-28149",
  firebaseStorageBucket: "diginext-28149.appspot.com",
  firebaseMessagingSenderId: "482265957598",
  firebaseAppId: "1:482265957598:web:5ecc05efdbed5c63f42e4f",
  tatvaRedirect: "https://diginextdoctor72093uat.azureedge.net/#/content?auto",
  gynec_api_url:
    "https://pm-medicalhistory-qa.tatvacare.in/api/v1/gynec-history",
  obstetric_api_url:
    "https://pm-medicalhistory-qa.tatvacare.in/api/v1/obstetric-history",
  tatvaRedirect: "https://doctor-uat.tatvacare.in#bypass_pedia=false",
  gynec_api_url:
    "https://pm-medicalhistory-qa.tatvacare.in/api/v1/gynec-history",
  obstetric_api_url:
    "https://pm-medicalhistory-qa.tatvacare.in/api/v1/obstetric-history",
  zydus_api_url: `https://pm-ingest-webhook-qa.tatvacare.in`,
  zydus_business_id: "754811713438773",
  rx_digitization: "https://pm-rxdigitization-qa.tatvacare.in",
  visit_api_url: "https://pm-visit-integration-qa.tatvacare.in",
  user_management_api_url: "https://user-management77913uat.azurewebsites.net",
  razorpay_integration_url: "https://pm-visit-integration-qa.tatvacare.in",
  api_secret_key: "194627f7-u6hu-4378-q0e2-a34t5lt77f31",
  api_key: "TC_12o89l11327dfrt55",
  lab_params_api_url: "https://pm-patient-docs-qa.tatvacare.in",
  opd_encryption_url:
    "https://api-uat.mytatva.in/api/v8/helper/encrypt_visit_data",
  opd_visit_url: "https://visit-enrolment-tatva.getvisitapp.net",
  upload_doc_api_url: "https://pm-patient-docs-qa.tatvacare.in",
  central_auth_api_url: "https://pm-central-auth-qa.tatvacare.in",
  pedia_logout_url: "https://doctor-uat.tatvacare.in/#logout_user=1",
  bulk_messages: "https://pm-communication-qa.tatvacare.in",
  searchengine_url: "https://pm-searchengine-qa.tatvacare.in",
  razorPay_key: "rzp_test_PoLtBba5t8qJIm",
  tatvaAi_api_url: "https://pm-doctor-tatva-qa.tatvacare.in",
  tatvaAi_url: "https://tatva-ai-uat.tatvacare.in",
  tatvaAi_logout_url:"https://tatva-ai-uat.tatvacare.in/logout",
  lite_api_key: "68ceb696-0b60-47e8-9deb-b0e359d93d2f",
  lite_secret_key: "4b301416-946d-4b22-a083-69111ce79245",
  gen_rx_api_url: "https://pm-rxdigitization-qa.tatvacare.in",
  tatvaPedia_api_url: "https://diginext-authserver-uat.tatvacare.in", // for the future use
  tatvaPedia_domain_url: "https://diginextdoctor72093uat.azureedge.net",
};

const qa = {
  appointment_api_url: `https://node-doctor.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  symptoms_api_url: `https://strauss-symptoms.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  examination_api_url: `https://strauss-examination.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  diagnosis_api_url: `https://strauss-diagnosis.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  advice_api_url: `https://strauss-advice.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  investigation_api_url: `https://strauss-investigation.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  medication_api_url: `https://strauss-medicine.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  vitals_api_url: `https://strauss-vital.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  casemanager_api_url: `https://strauss-casemanager.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  printsettings_api_url: `https://strauss-printsettings.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  medicalhistory_api_url: `https://strauss-medicalhistory.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  videolibrary_api_url: `https://strauss-videolibrary.salmonstone-47e08067.centralindia.azurecontainerapps.io`,
  sso_to_pm_url: `https://pms-upgrade.azurewebsites.net/api/get_doctor_sso_token.php`,
  sso_to_pm_admin_url: `https://pms-upgrade.azurewebsites.net/api/get_doctor_admin_sso_token.php`,
  sso_to_pm_username: `PM_40d30f01184aedc47`,
  sso_to_pm_password: `487154d8-b9ad-4314-a0e3-a72d5se84x14`,
  doctor_website_url: `https://pms-upgrade.azurewebsites.net/doctor_website/`,
  vaccination_api_url: `https://pm-vaccination-uat.mytatva.in/`,
  GROWTHBOOK_CLIENTKEY: "sdk-8jXEPwxajRuwkiyD",
  growth_chart_api_url: `https://pm-uat-growth-chart.tatvacare.in`,
  firebaseApiKey: "AIzaSyAfD-YLOjDLbhC7hwyiumSkNxP2lul_Kc0",
  firebaseAuthDomain: "diginext-28149.firebaseapp.com",
  firebaseDatabaseURL: "https://tc-care-default-rtdb.firebaseio.com",
  firebaseProjectId: "diginext-28149",
  firebaseStorageBucket: "diginext-28149.appspot.com",
  firebaseMessagingSenderId: "482265957598",
  firebaseAppId: "1:482265957598:web:5ecc05efdbed5c63f42e4f",
  tatvaRedirect: "https://diginextdoctor72093uat.azureedge.net/#/content?auto",
  gynec_api_url:
    "https://pm-medicalhistory-uat.tatvacare.in/api/v1/gynec-history",
  obstetric_api_url:
    "https://pm-medicalhistory-uat.tatvacare.in/api/v1/obstetric-history",
  zydus_api_url: `https://pm-ingest-webhook-uat.tatvacare.in`,
  zydus_business_id: "754811713438773",
  zydus_proxy_url: "https://pm-ict-proxy-uat.tatvacare.in",
  rx_digitization: "https://pm-rxdigitization-uat.tatvacare.in",
  visit_api_url: "https://pm-visit-integration-uat.tatvacare.in",
  user_management_api_url: "https://user-management77913uat.azurewebsites.net",
  razorpay_integration_url: "https://pm-razorpay-uat-integration.tatvacare.in",
  api_secret_key: "194627f7-u6hu-4378-q0e2-a34t5lt77f31",
  api_key: "TC_12o89l11327dfrt55",
  lab_params_api_url: "https://pm-patient-docs-uat.tatvacare.in",
  opd_encryption_url:
    "https://api-uat.mytatva.in/api/v8/helper/encrypt_visit_data",
  opd_visit_url: "https://visit-enrolment-tatva.getvisitapp.net",
  upload_doc_api_url: "https://pm-patient-docs-uat.tatvacare.in",
  central_auth_api_url: "https://pm-central-auth-uat.tatvacare.in",
  pedia_logout_url: "https://doctor-uat.tatvacare.in/#logout_user=1",
  bulk_messages: "https://pm-communication-uat.tatvacare.in",
  searchengine_url: "https://pm-searchengine-uat.tatvacare.in",
  razorPay_key: "rzp_test_PoLtBba5t8qJIm",
  tatvaAi_api_url: "https://pm-doctor-tatva-uat.tatvacare.in",
  tatvaAi_url: "https://tatva-ai-uat.tatvacare.in",
  tatvaAi_logout_url:"https://tatva-ai-uat.tatvacare.in/logout",
  lite_api_key: "68ceb696-0b60-47e8-9deb-b0e359d93d2f",
  lite_secret_key: "4b301416-946d-4b22-a083-69111ce79245",
  gen_rx_api_url: "https://pm-rxdigitization-qa.tatvacare.in",
  tatvaPedia_api_url: "https://diginext-authserver-uat.tatvacare.in", // for the future use
  tatvaPedia_domain_url: "https://diginextdoctor72093uat.azureedge.net",
};

const uat = {
  appointment_api_url: `https://pm-master-uat-webservice.tatvacare.in`,
  symptoms_api_url: `https://pm-symptoms-uat.tatvacare.in`,
  examination_api_url: `https://pm-examination-uat.tatvacare.in`,
  diagnosis_api_url: `https://pm-diagnosis-uat.tatvacare.in`,
  advice_api_url: `https://pm-advice-uat.tatvacare.in`,
  investigation_api_url: `https://pm-investigation-uat.tatvacare.in`,
  medication_api_url: `https://pm-medicine-uat.tatvacare.in/`,
  vitals_api_url: `https://pm-vital-uat.tatvacare.in`,
  casemanager_api_url: `https://pm-casemanager-uat.tatvacare.in`,
  printsettings_api_url: `https://pm-printsetting-uat.tatvacare.in`,
  medicalhistory_api_url: `https://pm-medicalhistory-uat.tatvacare.in`,
  videolibrary_api_url: `https://pm-videolibrary-uat.tatvacare.in`,
  sso_to_pm_url: `https://pm-uat-dhspl-2.tatvacare.in/api/get_doctor_sso_token.php`,
  sso_to_pm_admin_url: `https://pm-uat-dhspl-2.tatvacare.in/api/get_doctor_admin_sso_token.php`,
  sso_to_pm_username: `PM_40d30f01184aedc47`,
  sso_to_pm_password: `487154d8-b9ad-4314-a0e3-a72d5se84x14`,
  doctor_website_url: `https://pm-uat-dhspl-2.tatvacare.in/doctor_website/`,
  vaccination_api_url: `https://pm-vaccination-uat.mytatva.in/`,
  GROWTHBOOK_CLIENTKEY: "sdk-8jXEPwxajRuwkiyD",
  growth_chart_api_url: `https://pm-uat-growth-chart.tatvacare.in`,
  firebaseApiKey: "AIzaSyAfD-YLOjDLbhC7hwyiumSkNxP2lul_Kc0",
  firebaseAuthDomain: "diginext-28149.firebaseapp.com",
  firebaseDatabaseURL: "https://tc-care-default-rtdb.firebaseio.com",
  firebaseProjectId: "diginext-28149",
  firebaseStorageBucket: "diginext-28149.appspot.com",
  firebaseMessagingSenderId: "482265957598",
  firebaseAppId: "1:482265957598:web:5ecc05efdbed5c63f42e4f",
  tatvaRedirect: "https://diginextdoctor72093uat.azureedge.net/#/content?auto",
  gynec_api_url:
    "https://pm-medicalhistory-uat.tatvacare.in/api/v1/gynec-history",
  obstetric_api_url:
    "https://pm-medicalhistory-uat.tatvacare.in/api/v1/obstetric-history",
  tatvaRedirect: "https://doctor-uat.tatvacare.in#bypass_pedia=false",
  gynec_api_url:
    "https://pm-medicalhistory-uat.tatvacare.in/api/v1/gynec-history",
  obstetric_api_url:
    "https://pm-medicalhistory-uat.tatvacare.in/api/v1/obstetric-history",
  zydus_api_url: `https://pm-ingest-webhook-uat.tatvacare.in`,
  zydus_business_id: "754811713438773",
  zydus_proxy_url: "https://pm-ict-proxy-uat.tatvacare.in",
  rx_digitization: "https://pm-rxdigitization-uat.tatvacare.in",
  visit_api_url: "https://pm-visit-integration-uat.tatvacare.in",
  user_management_api_url: "https://user-management77913uat.azurewebsites.net",
  razorpay_integration_url: "https://pm-razorpay-uat-integration.tatvacare.in",
  api_secret_key: "194627f7-u6hu-4378-q0e2-a34t5lt77f31",
  api_key: "TC_12o89l11327dfrt55",
  lab_params_api_url: "https://pm-patient-docs-uat.tatvacare.in",
  opd_encryption_url:
    "https://api-uat.mytatva.in/api/v8/helper/encrypt_visit_data",
  opd_visit_url: "https://visit-enrolment-tatva.getvisitapp.net",
  upload_doc_api_url: "https://pm-patient-docs-uat.tatvacare.in",
  central_auth_api_url: "https://pm-central-auth-uat.tatvacare.in",
  pedia_logout_url: "https://doctor-uat.tatvacare.in/#logout_user=1",
  bulk_messages: "https://pm-communication-uat.tatvacare.in",
  searchengine_url: "https://pm-searchengine-uat.tatvacare.in",
  razorPay_key: "rzp_test_PoLtBba5t8qJIm",
  tatvaAi_api_url: "https://pm-doctor-tatva-uat.tatvacare.in",
  tatvaAi_url: "https://tatva-ai-uat.tatvacare.in",
  tatvaAi_logout_url:"https://tatva-ai-uat.tatvacare.in/logout",
  lite_api_key: "68ceb696-0b60-47e8-9deb-b0e359d93d2f",
  lite_secret_key: "4b301416-946d-4b22-a083-69111ce79245",
  gen_rx_api_url: "https://pm-rxdigitization-uat.tatvacare.in",
  tatvaPedia_api_url: "https://diginext-authserver-uat.tatvacare.in", // for the future use
  tatvaPedia_domain_url: "https://diginextdoctor72093uat.azureedge.net",
};

const prod = {
  appointment_api_url: `https://pm-master-prod-webservice.tatvacare.in`,
  symptoms_api_url: `https://pm-symptoms-prod.tatvacare.in`,
  examination_api_url: `https://pm-examination-prod.tatvacare.in`,
  diagnosis_api_url: `https://pm-diagnosis-prod.tatvacare.in`,
  advice_api_url: `https://pm-advice-prod.tatvacare.in`,
  investigation_api_url: `https://pm-investigation-prod.tatvacare.in`,
  medication_api_url: `https://pm-medicine-prod.tatvacare.in/`,
  vitals_api_url: `https://pm-vital-prod.tatvacare.in`,
  casemanager_api_url: `https://pm-casemanager-prod.tatvacare.in`,
  printsettings_api_url: `https://pm-printsetting-prod.tatvacare.in`,
  medicalhistory_api_url: `https://pm-medicalhistory-prod.tatvacare.in`,
  videolibrary_api_url: `https://pm-videolibrary-prod.tatvacare.in`,
  sso_to_pm_url: `https://practice.tatvacare.in/api/get_doctor_sso_token.php`,
  sso_to_pm_admin_url: `https://practice.tatvacare.in/api/get_doctor_admin_sso_token.php`,
  sso_to_pm_username: `PM_45dy48vh8sc4i1dum`,
  sso_to_pm_password: `481541at-j4xc-4817-q5xz-a4rt48c69bt1`,
  doctor_website_url: `https://practice.tatvacare.in/doctor_website/`,
  vaccination_api_url: `https://pm-vaccination-prod.tatvacare.in/`,
  GROWTHBOOK_CLIENTKEY: "sdk-qAxUqghZDXqcMH45",
  firebaseApiKey: "AIzaSyDijmTNFqGW8047ELts2cztM88mibYrjvw",
  firebaseAuthDomain: "tatvacare.firebaseapp.com",
  firebaseDatabaseURL: "https://tatvacare.firebaseio.com",
  firebaseProjectId: "tatvacare",
  firebaseStorageBucket: "tatvacare.appspot.com",
  firebaseMessagingSenderId: "601922359186",
  firebaseAppId: "1:601922359186:web:a3b9df05589faed1f5fb4b",
  growth_chart_api_url: `https://pm-prod-growth-chart.tatvacare.in`,
  tatvaRedirect: "https://tatvapedia.tatvacare.in#bypass_pedia=false",
  gynec_api_url:
    "https://pm-medicalhistory-prod.tatvacare.in/api/v1/gynec-history",
  obstetric_api_url:
    "https://pm-medicalhistory-prod.tatvacare.in/api/v1/obstetric-history",
  zydus_api_url: `https://pm-ingest-webhook-prod.tatvacare.in`,
  zydus_business_id: "368451724046474",
  zydus_proxy_url: 'https://pm-ict-proxy.tatvacare.in',
  rx_digitization: "https://pm-rxdigitization-prod.tatvacare.in",
  visit_api_url: "https://pm-visit-integration-prod.tatvacare.in",
  lab_params_api_url: "https://pm-patient-docs-prod.tatvacare.in",
  user_management_api_url: "https://diginext-usermgmt-prod.tatvacare.in",
  razorpay_integration_url: "https://pm-razorpay-uat-integration.tatvacare.in",
  api_secret_key: "184028f7-a9dh-4518-k1f2-q07t5mn11g72",
  api_key: "TC_01o89208247drot41",
  opd_encryption_url: "https://api.mytatva.in/api/v8/helper/encrypt_visit_data",
  opd_visit_url: "https://visit-enrolment-tatva.getvisitapp.com",
  upload_doc_api_url: "https://pm-patient-docs-prod.tatvacare.in",
  central_auth_api_url: "https://pm-central-auth-prod.tatvacare.in",
  pedia_logout_url: "https://diginext-authserver-prod.tatvacare.in/logout?post_logout_redirect_uri=https://tatvapedia.tatvacare.in&client_id=client",
  bulk_messages: "https://pm-communication-prod.tatvacare.in",
  searchengine_url: "https://pm-searchengine-prod.tatvacare.in",
  razorPay_key: "rzp_live_GvLkPHHNSMs2G3",
  tatvaAi_api_url: "https://pm-doctor-tatva-prod.tatvacare.in",
  tatvaAi_url: "https://tatva-ai.tatvacare.in",
  tatvaAi_logout_url:"https://tatva-ai.tatvacare.in/logout",
  lite_api_key: "68ceb696-0b60-47e8-9deb-b0e359d93d2f",
  lite_secret_key: "4b301416-946d-4b22-a083-69111ce79245",
  gen_rx_api_url: "https://pm-rxdigitization-prod.tatvacare.in",
  tatvaPedia_api_url: "https://diginext-authserver-prod.tatvacare.in",
  tatvaPedia_domain_url: "https://tatvapedia.tatvacare.in", 
};

const getEnv = () => {
  switch (process.env.REACT_APP_ENV) {
    case "dev":
      return uat;
    case "qa_tp":
      return qa_tp;
    case "qa":
      return qa;
    case "uat":
      return uat;
    case "prod":
      return prod;
    default:
      break;
  }
};
export const env = getEnv();
